import { useNavigate, useParams } from "react-router";
import { useSamplesAirMicrobialBaseDataShowQuery } from "@/services/backend/samples/api/air-microbial-base-data-api";
import { AirMicrobialBaseDataFields } from "@/services/backend/samples/components/air-microbial-base-data-fields";
import { DeleteAirMicrobialBaseDataDialog } from "@/services/backend/samples/components/delete-air-microbial-base-data-dialog";
import { SampleBaseDataDetailCard } from "@/routes/base-data/samples/_components/sample-base-data-detail-card";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function AirMicrobialBaseDataRoute() {
  const { baseDataId } = useParams();
  const navigate = useNavigate();

  const {
    data: baseData,
    isLoading,
    error,
  } = useSamplesAirMicrobialBaseDataShowQuery({ id: baseDataId! });

  return (
    <PersistenceContextProvider>
      <SampleBaseDataDetailCard
        baseData={baseData}
        isLoading={isLoading}
        error={error}
        actions={
          baseData && (
            <DeleteAirMicrobialBaseDataDialog
              baseData={baseData}
              onDeleted={() => navigate("..")}
            />
          )
        }
      >
        {baseData && <AirMicrobialBaseDataFields id={baseData.id} />}
      </SampleBaseDataDetailCard>
    </PersistenceContextProvider>
  );
}
